import { render } from "./editAppointment.vue?vue&type=template&id=fbf6b8aa"
import script from "./editAppointment.vue?vue&type=script&lang=js"
export * from "./editAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__